import { render } from "./myNotif.vue?vue&type=template&id=79092a6a&scoped=true"
import script from "./myNotif.vue?vue&type=script&lang=js"
export * from "./myNotif.vue?vue&type=script&lang=js"

import "./myNotif.vue?vue&type=style&index=0&id=79092a6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79092a6a"]])

export default __exports__